module.exports = __webpack_public_path__ + "media/images/p-about/partner/三方よし基金-9cef1ce8b84c1895bcdbdb51d30a2a41.png";